import { ERROR_CODES, ORDER_METHODS } from '../../services/exports/Constants';
import ReduxActions from '../../store/ReduxActions';
import { actionCreators } from '../../store/actions';
import { setTableNotice } from '../../store/slices/OrderMethodSlice';
import { TableLinkNotice } from '../../utils/on-site';

/** The table order can't be placed at this table: it was switched off or deleted, or table ordering stopped. */
export const TABLE_UNAVAILABLE_ERROR_CODES: string[] = [
  ERROR_CODES.ON_SITE_TABLE_UNAVAILABLE,
  ERROR_CODES.ON_SITE_UNAVAILABLE,
  ERROR_CODES.ROOM_SERVICE_LOCATION_UNAVAILABLE,
  ERROR_CODES.ROOM_SERVICE_UNAVAILABLE,
];

const TABLE_ORDERING_OFF_ERROR_CODES: string[] = [
  ERROR_CODES.ON_SITE_UNAVAILABLE,
  ERROR_CODES.ROOM_SERVICE_UNAVAILABLE,
];

/**
 * Drops a table the backend refused, so the guest isn't offered it again; the cart goes to pickup and
 * the menu says why (`TableAvailabilityNote`).
 */
export const dropUnavailableTable = (code?: string): void => {
  ReduxActions.dispatch(actionCreators.order.updateOrder({ method: ORDER_METHODS.PICKUP, on_site_table: null }));
  ReduxActions.dispatch(
    setTableNotice(
      TABLE_ORDERING_OFF_ERROR_CODES.includes(code)
        ? TableLinkNotice.TableOrderingOff
        : TableLinkNotice.TableUnavailable,
    ),
  );
};

/** 422 fields that refuse the table itself (switched off, deleted, or another restaurant's). */
const TABLE_RULES = ['on_site_table_id', 'room_service_location_id'];

/** Drops the table when a 422 refused it; other order-method fields leave it alone. Whether it was dropped. */
export const dropRefusedTable = (rules: Record<string, unknown> | null | undefined): boolean => {
  if (!Object.keys(rules ?? {}).some((rule) => TABLE_RULES.includes(rule))) {
    return false;
  }

  dropUnavailableTable();

  return true;
};
